import { useState } from 'react';

import { useBlocker } from 'react-router-dom';

import { CloseDrawerGuard as CloseDrawerGuardBase } from '@cast/shared-rff-ui';

type Props = Omit<
  React.ComponentProps<typeof CloseDrawerGuardBase>,
  'blocker' | 'onFormDirtyChange'
>;

export const CloseDrawerGuard = ({
  isDirty: externalIsDirty = false,
  formGuard = true,
  ...rest
}: Props) => {
  const [isFormDirty, setIsFormDirty] = useState(false);
  const isDirty = externalIsDirty || isFormDirty;
  const blocker = useBlocker(isDirty);
  return (
    <CloseDrawerGuardBase
      isDirty={isDirty}
      formGuard={formGuard}
      blocker={blocker}
      onFormDirtyChange={setIsFormDirty}
      {...rest}
    />
  );
};
